import { getDomainConfig } from "../config/config";

export function getLanguageCode(isGlobal,addSlash = false) {
  const langPrefix = window.location.href.split("/");

  if (isGlobal === 'Atd' && addSlash) return '/' + langPrefix[3]
  else if (isGlobal === 'Atd' && !addSlash) return langPrefix[3];
  return '';
}

export function addGeoParam() {

  const config = getDomainConfig();
  if (config.brand === "Atd") {

    const langPrefix = getLanguageCode('Atd');
    let langCode = '';

    switch(langPrefix) {
      case 'de':
        langCode = 'de-de'
        break;
      case 'au':
        langCode = 'en-au'
      break;
        case 'us':
        langCode = 'en-us'
        break;
      default:
        langCode = langPrefix
    }
    return langCode;
  }
  return '';
}
